import { Grid } from "@mui/material"

export const PrivacyPolicy = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'} width={'100%'} height={'100%'}>
            <iframe src={'/KaziPrivacyPolicyV1.pdf'} height={'600px'}/>
        </Grid>
    )
}